import request from '@/utils/request'
import type {
  GetDeviceFlyLogsItem,
  MalfunctionRepairDeviceItem,
  GetMalfunctionRepairDevicesQuery,
  GetWarehouseListParams,
  GetWarehouseListResult,
  CreateMulfunctionRepairOrderParams,
  MalfunctionRepairServiceOrderDetail,
  MalfunctionRepairServiceOrderApplyInfo,
  MalfunctionRepairRepairOrderDetail,
  MalfunctionRepairRepairOrderQualitativeInfo,
  MalfunctionRepairRepairOrderDetectInfo,
  MalfunctionRepairRepairOrderClaimInfo,
  GetMalfunctionRepairUavLogsQuery,
  GetMalfunctionRepairOrderListItem,
  ConfirmOrderRepairParams,
  UploadOrderClaimInfoParams,
  ConfirmPayOrderPrams,
  ConfirmPayOrderResult,
  GetOrderAssociatedResponsibleResult,
  FlyLogAppealParams,
  GetFlyLogAppealDetailResult,
  GetRepairOrderAnalysisReportResult,
  FlylogAnalysisResult,
  AppealResponsibleWordOrderParams,
  GetServiceOrderQualitativeResult,
  GetDeviceFlyLogBoomInfo,
  NewEvaluateParams,
  ServiceChargeDetail,
  ConfirmPayServiceChargePrams,
  CheckServiceChargePayStatusResult,
  ServiceChargePayDetail,
  UpgradeMaintenanceDetailAPI,
  AreaListDataItem,
  CreateOrderReturnData,
  CancelServiceOrderParams,
  AddOrUpdatePayOrderParams,
  GetPayOrderDetailResult,
  confirmPayTechnicalSupportParams,
  confirmPayTechnicalSupportResult,
  TechnicalSupportInvoiceListItem,
  GetFaultWarningOrderBySnResult,
  ResetEquipmentExtendResult,
} from '@/types/malfunction-repair'
import type { OrderSubmitInvoiceData } from '@/types/invoice'
import type { XssCommonPageListQuery, XssCommonPageListResult } from '@/types/public'
import { updateUserGuideStatus } from './device-replace-v3'

// 获取设备列表
export function getRepairDeviceList(
  params: GetMalfunctionRepairDevicesQuery
): Promise<XssCommonPageListResult<MalfunctionRepairDeviceItem>> {
  return request.get('/api/agri/v2/equipment/me', { params })
}

// 获取设备详情
export function getRepairDeviceDetail(serial_number: string): Promise<MalfunctionRepairDeviceItem> {
  return request.get(`/api/agri/v2/equipment/${serial_number}`)
}

// 获取飞行日志
export function getDeviceFlyLogs(
  params: GetMalfunctionRepairUavLogsQuery
): Promise<XssCommonPageListResult<GetDeviceFlyLogsItem>> {
  console.log('params', params)
  return request.get(`/api/agri/v2/fly_log`, { params })
}
// 获取飞行日志炸机信息
export function getFlyLogBoomInfo(guid: string): Promise<GetDeviceFlyLogBoomInfo> {
  return request.post(`/api/agri/v2/fly_log/${guid}/analysis_boom`)
}
// 飞行日志分析
export function analysisFlylog(guid: string): Promise<FlylogAnalysisResult> {
  return request.post(`/api/agri/v2/fly_log/${guid}/analysis`)
}
// 获取最新飞行日志
export function getLastFlyLog(serial_number: string): Promise<GetDeviceFlyLogsItem> {
  return request.get('/api/agri/v2/fly_log/last_fly_log', { params: { serial_number } })
}

// 获取维修网点列表
export function getRepairWarehouseList(
  params: GetWarehouseListParams
): Promise<GetWarehouseListResult> {
  return request.post(`/api/agri/v2/repair_warehouse`, params)
}

// 提单
export function createOrder(
  params: CreateMulfunctionRepairOrderParams
): Promise<CreateOrderReturnData> {
  return request.post('/api/agri/v2/after_sales/apply', params)
}

// 获取服务单详情
export function getServiceOrderDetail(guid: string): Promise<MalfunctionRepairServiceOrderDetail> {
  return request.get(`/api/agri/v2/after_sales/${guid}`)
}
// 获取服务单详情 - 提单内容
export function getServiceOrderDetailApplyInfo(
  guid: string
): Promise<MalfunctionRepairServiceOrderApplyInfo> {
  return request.get(`/api/agri/v2/after_sales/${guid}/apply_info`)
}

// 获取维修单详情
export function getRepairOrderDetail(guid: string): Promise<MalfunctionRepairRepairOrderDetail> {
  return request.get(`/api/agri/repair/repair_order_detail?guid=${guid}`)
}
// 提交维修单发票信息
export function submitRepairOrderInvoiceInfo(
  guid: string,
  params: OrderSubmitInvoiceData
): Promise<void> {
  return request.post(`/api/agri/repair/${guid}/invoice_apply_info`, params)
}

// 获取维修单 - 权益详情
export function getRepairOrderQualitativeInfo(
  guid: string
): Promise<MalfunctionRepairRepairOrderQualitativeInfo> {
  return request.get(`/api/agri/v2/repair/${guid}/qualitative`)
}
// 获取维修单 - 检测情况
export function getRepairOrderDetectInfo(
  guid: string
): Promise<MalfunctionRepairRepairOrderDetectInfo> {
  return request.get(`/api/agri/repair/get_detect_info?guid=${guid}`)
}

// 获取维修单 - 理赔资料
export function getRepairOrderDClaimInfo(
  guid: string
): Promise<MalfunctionRepairRepairOrderClaimInfo> {
  return request.get(`/api/agri/v2/repair/claim/${guid}`)
}
// 上传理赔资料
export function uploadOrderClaimInfo(params: UploadOrderClaimInfoParams): Promise<void> {
  return request.post(`/api/agri/v2/repair/claim/${params.guid}/policy`, params)
}
// 获取单据列表
export function getRepairOrderList(
  params: XssCommonPageListQuery & { status: string }
): Promise<XssCommonPageListResult<GetMalfunctionRepairOrderListItem>> {
  return request.get('/api/agri/after_sales', { params })
}

// 更换维修网点
export function changeOrderRepairWahouse(
  guid: string,
  params: {
    warehouse_guid: string
    warehouse_type: string
  }
): Promise<void> {
  return request.post(`/api/agri/v2/after_sales/${guid}/exchange`, params)
}

// 确认维修
export function confirmOrderRepair(params: ConfirmOrderRepairParams): Promise<void> {
  return request.post('/api/agri/repair/confirm_estimate', params)
}

// 确认支付
export function confirmPayRepairOrder(
  params: ConfirmPayOrderPrams
): Promise<ConfirmPayOrderResult> {
  return request.post('/api/agri/repair/pay', params)
}
// 查询维修单支付状态
export function checkRepairOrderPayStatus(guid: string): Promise<boolean> {
  return request.get(`/api/agri/repair/repair_order_is_pay?guid=${guid}`)
}

// 查看定责详情
export function getOrderAssociatedResponsible(
  guid: string
): Promise<GetOrderAssociatedResponsibleResult> {
  return request.get(`/api/agri/v2/after_sales_services/services_associated_responsible/${guid}`)
}
// 72小时日志申诉
export function flyLogAppeal(params: FlyLogAppealParams): Promise<void> {
  return request.post(`/api/agri/v2/after_sales_services/fly/${params.guid}/appeal`, params)
}
// 72小时日志详情
export function GetFlyLogAppealDetail(
  after_sales_no: string
): Promise<GetFlyLogAppealDetailResult> {
  return request.get(`/api/agri/v2/after_sales_services/fly/${after_sales_no}`)
}
// 获取分析报告详情
export function GetRepairOrderAnalysisReport(
  guid: string
): Promise<GetRepairOrderAnalysisReportResult> {
  return request.get(`/api/app/after_sales_services/services_associated_responsible/${guid}/pdf`)
}

// 申请技术定责
export function ApplyTechnicalSupport(guid: string): Promise<void> {
  return request.post(
    `/api/agri/v2/after_sales_services/responsible_work_order/${guid}/apply_technical_support`
  )
}
// 确认技术定责
export function confirmTechnicalSupport(guid: string): Promise<void> {
  return request.post(`/api/agri/v2/after_sales_services/responsible_work_order/${guid}/confirm`)
}
// 定责结果申诉
export function appealResponsibleWordOrder(
  params: AppealResponsibleWordOrderParams
): Promise<void> {
  return request.post(
    `/api/agri/v2/after_sales_services/responsible_work_order/${params.guid}/appeal`,
    params
  )
}

// 取消维修单
export function cancelService(guid: string): Promise<void> {
  return request.post(`/api/agri/after_sales/${guid}/cancel`)
}

// 获取服务单权益
export function getServiceOrderQualitative(
  guid: string
): Promise<GetServiceOrderQualitativeResult> {
  return request.get(`/api/agri/v2/after_sales/${guid}/qualitative`)
}

// 服务单评价
export function evalUateServiceOrder(guid: string, params: NewEvaluateParams): Promise<void> {
  return request.post(`/api/agri/after_sales/${guid}/appraise`, params)
}

// 服务费用单详情
export function getserviceChargeDetail(guid: string): Promise<ServiceChargeDetail> {
  return request.get(`/api/agri/after_sales/charge_orders/${guid}`)
}
// 服务费用单提交发票
export function submitServiceChargeInvoice(
  guid: string,
  params: OrderSubmitInvoiceData
): Promise<void> {
  return request.post(`/api/agri/after_sales/charge_orders/${guid}/invoice_apply_info`, params)
}

// 服务费用单支付
export function confirmPayServiceCharge(
  guid: string,
  params: ConfirmPayServiceChargePrams
): Promise<ConfirmPayOrderResult> {
  return request.post(`/api/agri/after_sales/charge_orders/${guid}/pay`, params)
}

// 服务费用单支付状态
export function checkServiceChargePayStatus(
  pay_order_no: string
): Promise<CheckServiceChargePayStatusResult> {
  return request.get(
    `/api/agri/after_sales/charge_orders/pay_order/check?pay_order_no=${pay_order_no}`
  )
}

// 服务费用单支付详情
export function getServiceChargePayDetail(guid: string): Promise<ServiceChargePayDetail> {
  return request.get(`/api/agri/after_sales/charge_orders/${guid}/pay_order`)
}

// 升级保养详情
export function getUpgradeMaintenanceDetail(guid: string): Promise<UpgradeMaintenanceDetailAPI> {
  return request.get(`/api/agri/repair/upgrade_detail/${guid}`)
}

// 地址列表
export function getAreaList(params: {
  keywords?: string
  level?: number
  upid: number
}): Promise<Array<AreaListDataItem>> {
  let paramsStr = '?'
  if (params.keywords !== undefined) {
    paramsStr = paramsStr + 'keywords=' + params.keywords
  }
  if (params.level !== undefined) {
    paramsStr = (paramsStr === '?' ? paramsStr : paramsStr + '&') + 'level=' + params.level
  }
  if (params.upid !== undefined) {
    paramsStr = (paramsStr === '?' ? paramsStr : paramsStr + '&') + 'upid=' + params.upid
  }
  return request.get(`/api/agri/common/areas${paramsStr}`)
}

// 获取取消原因
export function getRepairCancelOption(): Promise<Record<string, string>> {
  return request.get('/api/agri/v2/after_sales/cancel_reason')
}

// 提交取消原因
export function requestCancelOrder(guid: string, params: CancelServiceOrderParams): Promise<void> {
  return request.post(`/api/agri/v2/after_sales/${guid}/cancel`, params)
}

export type GetIsSiteSubmission = {
  serial_number: string
  lng: number
  lat: number
  is_boom: boolean
  log: string
}
export type GetIsSiteSubmissionResult = {
  is_on_site: boolean
  on_site_exemption: number
  on_site_exemption_num: number
}
// 是否现场提单
export function getIsSiteSubmission(
  params: GetIsSiteSubmission
): Promise<GetIsSiteSubmissionResult> {
  return request.post(`/api/agri/v2/repair_warehouse/is_on_site`, params)
}

// 新增修改付费定责
export function addOrUpdatePayOrder(
  params: AddOrUpdatePayOrderParams,
  serviceGuid: string
): Promise<{
  guid: string
}> {
  return request.post(
    `/api/agri/v2/after_sales_services/pay_work_order/${serviceGuid}/apply_pay_technical_support`,
    params
  )
}

// 付费定责工单详情
export function getPayOrderDetail(guid: string): Promise<GetPayOrderDetailResult> {
  return request.get(`/api/agri/v2/after_sales_services/pay_work_order/get_pay_technical_support`, {
    params: {
      guid,
    },
  })
}

// 定责付费金额
export function getPayOrderPrice(guid: string): Promise<{
  price: number
}> {
  return request.get(`/api/app/after_sales_services/pay_work_order/get_pay_work_order_price`, {
    params: {
      guid,
    },
  })
}

export type submitServiceFeeTechnicalInvoiceParams = {
  pay_responsible_work_order_guid: string
  invoice_type: number // 发票类型 0: 普票 1: 专票
  bill_type: number
  header: string
  taxpayer_no: string
}

// 付费定责提交发票
export function submitServiceFeeTechnicalInvoice(
  params: submitServiceFeeTechnicalInvoiceParams
): Promise<void> {
  return request.post(`/api/agri/v2/after_sales_services/pay_work_order/add_invoice`, params)
}

// 取消付费定责工单
export function cancelPayOrder(guid: string): Promise<void> {
  return request.post(`/api/agri/v2/after_sales_services/pay_work_order/cancel`, {
    guid,
  })
}

// 付费定责发起支付
export function confirmPayTechnicalSupport(
  params: confirmPayTechnicalSupportParams
): Promise<confirmPayTechnicalSupportResult> {
  return request.post(`/api/agri/v2/after_sales_services/pay_work_order/pay`, params)
}

// 技术支持工单发票列表
export function getTechnicalSupportInvoiceList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<TechnicalSupportInvoiceListItem>> {
  return request.get(`/api/agri/v2/after_sales_services/pay_work_order/get_invoice_list`, {
    params,
  })
}

// 根据序列号查询是否存在未提交的工单
export function getFaultWarningOrderBySn(sn: string): Promise<GetFaultWarningOrderBySnResult> {
  return request.get('/api/app/fault_warning/order_by_sn', { params: { sn } })
}

// 重置设备质保时间
export function resetEquipmentExtend(
  serial_number: string
): Promise<ResetEquipmentExtendResult> {
  return request.get('/api/agri/v2/after_sales/reset_equipment_extend', {
    params: { serial_number },
  })
}
